/* eslint-disable react/forbid-component-props */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-no-bind */
import {EmbeddedCheckout, EmbeddedCheckoutProvider} from "@stripe/react-stripe-js";
import {Overlay, Popover} from "react-bootstrap";
import React, {useRef, useState} from "react";
import EventsAPI from "../../shared/modules/EventsAPI";
import NonMemberCartAPI from "../../shared/modules/NonMemberCartAPI";
import PropTypes from "prop-types";

const StripeCheckoutPage = ({
  options,
  sessionId,
  setIsOrderPlaced,
  setSessionId,
  setShowStripeCheckout,
  stripePromise
}) => {
  const backButtonRef = useRef(null);
  const [
    showPopover,
    setShowPopover
  ] = useState(false);

  const handleComplete = () => {
    setShowStripeCheckout(false);
    setIsOrderPlaced(true);
  };

  const handleGoBack = () => {
    if (sessionId) {
      NonMemberCartAPI.expireStripeSession(sessionId);
      setSessionId(null);
    }
    setShowStripeCheckout(false);
  };

  const handleClose = () => {
    setShowPopover(false);
  };

  const handleBackButton = () => {
    if (sessionId) {
      EventsAPI.trackContactEvent(
        "stripe_back_button_clicked",
        "session_id_exists"
      );
      setShowPopover(true);
    } else {
      EventsAPI.trackContactEvent(
        "stripe_back_button_clicked",
        "session_id_does_not_exist"
      );
      setShowStripeCheckout(false);
    }
  };

  return (
    <div>
      <div
        className="stripe"
      >
        <div className="header">
          <div>
            <div
              className="size-4 cursor-pointer back-button bg-no-repeat bg-center bg-cover bg-icon-chevron-left"
              onClick={handleBackButton}
              ref={backButtonRef}
            />
          </div>
        </div>
        <EmbeddedCheckoutProvider
          options={{
            ...options,
            "onComplete": handleComplete
          }}
          stripe={stripePromise}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </div>
      <Overlay
        placement="right"
        rootClose
        show={showPopover}
        target={backButtonRef.current}
      >
        <Popover
          className="z-[10000] max-w-[300px] w-[300px]"
          id="popover-cart-exit"
          placement="right"
          positionTop={0}
          style={{"position": "fixed"}}
        >
          <div className="text-center py-2 px-1 flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <div className="font-serif text-xl leading-tight">
                Are you sure you want to exit?
              </div>
              <div className="font-sans text-base leading-none">
                Your order details won&#39;t be saved.
              </div>
            </div>
            <div className="flex flex-col gap-1 items-stretch justify-center">
              <button
                className="button-primary button-md"
                onClick={handleClose}
                type="button"
              >
                Continue Checkout
              </button>
              <button
                className="button-outlined-white button-md"
                onClick={handleGoBack}
                type="button"
              >
                Exit Checkout
              </button>
            </div>
          </div>
        </Popover>
      </Overlay>
    </div>
  );
};

StripeCheckoutPage.propTypes = {
  "options": PropTypes.object.isRequired,
  "sessionId": PropTypes.string,
  "setIsOrderPlaced": PropTypes.func.isRequired,
  "setSessionId": PropTypes.func.isRequired,
  "setShowStripeCheckout": PropTypes.func.isRequired,
  "stripePromise": PropTypes.object.isRequired
};

StripeCheckoutPage.defaultProps = {"sessionId": null};

export default StripeCheckoutPage;
